module.exports = __webpack_public_path__ + "html/customer-select.component.html";